import StdListContext from 'contexts/StdListContext';
import React from 'react';

interface Props {
  id: string;
  children: React.ReactNode;
  gridTemplateColumns: string;
  style?: React.CSSProperties;
}

class StdList extends React.Component<Props> {
  render(): React.ReactNode {
    const { id, children, gridTemplateColumns } = this.props;

    return (
      <>
        <style>
          {`
        .std-list-row:hover {
          background-color: rgba(var(--color-primary-rgb), 0.1);
        }

        .std-list-row.selected {
          background-color: rgba(var(--color-primary-rgb), 0.1);
        }
        `}
        </style>
        <StdListContext.Provider value={{ id, gridTemplateColumns }}>
          <div
            id={id}
            style={this.props.style}
            className="std-list column w100 h100 b-2 bgd-gray-2"
          >
            {children}
          </div>
        </StdListContext.Provider>
      </>
    );
  }
}

export default StdList;
